import { useMutation } from "@tanstack/react-query";
import { ClassService } from "../../services/class.service";
import { IClassUpdateModel } from "../../models/Class";

export const useClassMutations = () => {
  const { mutate: updateClass } = useMutation<any, Error, { id: string; model: IClassUpdateModel }>(
    {
      mutationFn: async ({ id, model }) => ClassService.updateClassByGymListingId(id, model),
    }
  );

  return {
    updateClass,
  };
};
